import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import routing from "../../../routing";
import { useDispatch, useSelector } from "react-redux";
import { get } from "../../../actions/general";
import { getPosition } from "../../reducers/choir/actions";
import { ICh_StateTree } from "../../reducers/interfaces";

export const useChoir = () => {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    let choirId = pathname.slice(`/${routing.choir}/`.length);

    const choir = useSelector((state: ICh_StateTree) => state.choir);

    useEffect(() => {
        if (choir === 'error') return;
        if (choirId.length !== 24) {
            return;
        }
        if (!choir || choir._id !== choirId) {
            dispatch(getPosition(pathname));
        }
    }, [choir]);

    return { choir };

}